export enum MealOption {
  AnyMealOption,
  AllBreakfastOptions = 14,
  IncludesDinner = 99,
}
